"use client";

import Link from "next/link";
import Image from "next/image";
import { AuthForm } from "@/components/auth/auth-form";

export default function AuthPage() {
  return (
    <div
      className="min-h-svh flex flex-col p-6"
      style={{ backgroundColor: 'var(--theme-background)' }}
    >
      <div className="mb-8">
        <Link href="/" className="flex items-center gap-3">
          <Image
            src="/favicon.svg"
            alt="BrainUs LK"
            width={32}
            height={32}
            className="size-8"
          />
          <h1 className="pixel-font font-bold text-base md:text-lg" style={{ color: 'var(--theme-text)' }}>
            BrainUs Learn
          </h1>
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          <AuthForm />
        </div>
      </div>
    </div>
  );
}
